import React, { useEffect } from "react"
import { getSignature } from "carrot-api/signatureClient"
import { Loading } from "../../views/Loading"
import { useQueryParam, StringParam } from "use-query-params"

const SignatureContainer = () => {
  const [redirectUrl] = useQueryParam("redirect-url", StringParam)

  useEffect(() => {
    getSignature(redirectUrl).then((signatureEmbedUrl) => {
      window.location.href = signatureEmbedUrl
    })
  }, [redirectUrl])

  return <Loading />
}

export { SignatureContainer }
